export enum Timing {
  Current = 'Current',
  Upcoming = 'Upcoming',
  Past = 'Past'
}
